import { render, staticRenderFns } from "./NovaPartida.vue?vue&type=template&id=257ff63e&scoped=true"
import script from "./NovaPartida.vue?vue&type=script&lang=js"
export * from "./NovaPartida.vue?vue&type=script&lang=js"
import style0 from "./NovaPartida.vue?vue&type=style&index=0&id=257ff63e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257ff63e",
  null
  
)

export default component.exports